module.exports = __webpack_public_path__ + "img/clothing95.d20adf40.jpg";